import { quotation as quotationEn } from '../en/quotation';

export const quotation = {
  ...quotationEn,
  quotations: 'மேற்கோள்கள்',
  allQuotations: 'அனைத்து மேற்கோள்கள்',
  createQuotation: 'மேற்கோளை உருவாக்கு',
  quotationDetails: 'மேற்கோள் விவரங்கள்',
  status_draft: 'வரைவு',
  status_sent: 'அனுப்பப்பட்டது',
  status_accepted: 'ஏற்றுக்கொள்ளப்பட்டது',
  status_rejected: 'நிராகரிக்கப்பட்டது',
  status_expired: 'காலாவதியானது',
  status_converted: 'ஆர்டராக மாற்றப்பட்டது',
  convertToOrder: 'ஆர்டராக மாற்று',
};
